/* eslint-disable new-cap */
import { Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import AudioPlayer from '../../library/AudioPlayer';
import DestructableMeteor from '../DestructableMeteor';

export default class GameMeteor extends DestructableMeteor {
  constructor(game, x, y, num) {
    super(game, x, y);
    this.x = x;
    this.y = y;
    this.moveTween = null;
    this.originalPosition = { x, y };

    this.num = num;
    this.lockAnimation = false;

    if (num > 100) {
      this.text = game.add.bitmapText(0, -4, 'Nasalization', num, 25);
    }
    else {
      this.text = game.add.bitmapText(0, -4, 'Nasalization', num, 30);
    }

    this.text.setOrigin(.5);
    this.text.align = 'center';
    this.text.tint = '0x063138';

    this.sprite.add(this.text);

    this.game.add.existing(this.sprite);

    this.wholeMeteor.setInteractive({ draggable: true });

    this.wholeMeteor.on('dragstart', () => {this.onDragStart();});
    this.wholeMeteor.on('dragend', () => {this.onDragEnd();});
    this.wholeMeteor.on('drag', (pointer, dX, dY) => {this.onDragUpdate(pointer, dX, dY);});

    this.sprite.setScale(0);

    this.sprite.alpha = 0;
    this.sprite.angle = 50;

    this.AnimateIn();
  }

  AnimateIn() {
    Tweens.addTween(this.container, 800, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);
    Tweens.addTween(this.container, 500, { alpha: 1 }, Phaser.Math.Easing.None);
    Tweens.addTween(this.container, 800, { angle: 0 }, Phaser.Math.Easing.Back.Out);
  }

  onDragStart() {
    this.game.children.bringToTop(this.sprite);
    AudioPlayer.PlaySound(this.game, AudioPlayer.sounds.SELECT_METEOR);
    if (this.moveTween !== null) {
      this.moveTween.pause();
      this.game.tweens.killTweensOf(this.sprite);
    }
    this.floatingEnabled = false;
    Tweens.addTween(this.sprite, 500, { scaleX: 1.2, scaleY: 1.2 }, Phaser.Math.Easing.Back.Out);
  }

  onDragEnd() {
    this.floatingEnabled = true;
    Tweens.addTween(this.sprite, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);
  }

  onDragUpdate(pointer, dX, dY) {
    this.sprite.x = pointer.x;
    this.sprite.y = pointer.y;
    this.y = this.sprite.y;
    this.counter = 0;
  }

  Number() {
    return this.num;
  }

  GetCoords() {
    return { x: this.sprite.x, y: this.sprite.y };
  }

  GetSprite() {
    return this.sprite;
  }

  Explode() {
    super.Explode();
    this.text.alpha = 0;
  }

  LockAnimation() {
    AudioPlayer.PlaySound(this.game, AudioPlayer.sounds.CORRECT_METEOR);
    this.sprite.inputEnabled = false;
    this.floatingEnabled = false;
    this.wholeMeteor.disableInteractive();
    Tweens.addColorTween(this.wholeMeteor, 0x88ff88, 500);
    for (let i = 0; i < this.brokenRockPieces.length; i++) {
      Tweens.addColorTween(this.brokenRockPieces[i], 0x88ff88, 500);
    }

    this.moveTween = Tweens.addTween(this.sprite, 500, { x: 0, y: 0 }, Phaser.Math.Easing.Back.Out);
  }

  MoveTo(x, y) {
    AudioPlayer.PlaySound(this.game, AudioPlayer.sounds.INCORRECT_METEOR);
    this.floatingEnabled = false;
    this.moveTween = Tweens.addTween(this.sprite, 1000, { x, y }, Phaser.Math.Easing.Exponential, () => {
      this.floatingEnabled = true;
      this.counter = 0;
      this.y = y;
    });
  }
}